const selectors = {
  item: '[data-main-menu-text-item]',
  wrapper: '[data-text-items-wrapper]',
  text: '.navtext',
  isActive: 'data-menu-active',
  sectionOuter: '[data-header-wrapper]',
  underlineCurrent: 'data-underline-current',
  defaultItem: '.menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext',
};

let sections = {};
let defaultPositions = null;

class HoverLine {
  constructor(el) {
    this.wrapper = el;
    this.itemList = this.wrapper.querySelectorAll(selectors.item);
    this.sectionOuter = document.querySelector(selectors.sectionOuter);
    this.underlineCurrent = this.sectionOuter.getAttribute(selectors.underlineCurrent) === 'true';
    this.defaultItem = null;
    if (this.underlineCurrent) {
      this.defaultItem = this.wrapper.querySelector(selectors.defaultItem);
    }
    this.setDefault();
    document.fonts.ready.then(() => {
      this.init();
    });
  }

  init() {
    if (this.itemList.length) {
      this.listen();
      this.listenResize();

      this.textBottom = null;
      this.setHeight();

      if (defaultPositions) {
        if (this.defaultItem) {
          const startingLeft = this.defaultItem.offsetLeft || 0;
          this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
        }

        this.reset();
      } else {
        // initialize at left edge of first item im menu
        const startingLeft = this.sectionOuter.querySelector(selectors.item).offsetLeft;
        this.sectionOuter.style.setProperty('--bar-left', `${startingLeft}px`);
        this.sectionOuter.style.setProperty('--bar-width', '0px');
      }
      this.sectionOuter.style.setProperty('--bar-opacity', '1');
    }
  }

  unload() {
    document.removeEventListener('theme:resize', this.reset);
    defaultPositions = null;
  }

  listenResize() {
    document.addEventListener('theme:resize', this.reset.bind(this));
  }

  setDefault() {
    if (this.defaultItem) {
      defaultPositions = {
        left: this.defaultItem.offsetLeft || null,
        width: this.defaultItem.clientWidth || null,
      };
    }
  }

  setHeight() {
    const height = this.wrapper.clientHeight;
    const text = this.itemList[0].querySelector(selectors.text);
    const textHeight = text.clientHeight;
    const textBottom = Math.floor(height / 2 - textHeight / 2) - 4;
    if (this.textBottom !== textBottom) {
      this.sectionOuter.style.setProperty('--bar-text', `${textHeight}px`);
      this.sectionOuter.style.setProperty('--bar-bottom', `${textBottom}px`);
      this.textBottom = textBottom;
    }
  }

  listen() {
    this.itemList.forEach((element) => {
      element.addEventListener('mouseenter', (evt) => {
        const item = evt.target.querySelector(selectors.text);
        this.startBar(item);
      });
    });
    this.wrapper.addEventListener('mouseleave', this.clearBar.bind(this));
  }

  startBar(item) {
    this.setHeight();
    let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
    let left = item.offsetLeft;
    let width = item.clientWidth;
    if (active) {
      this.render(width, left);
    } else {
      this.sectionOuter.setAttribute(selectors.isActive, true);
      this.render(0, left);
      setTimeout(() => {
        this.render(width, left);
      }, 10);
    }
  }

  render(width, left) {
    this.sectionOuter.style.setProperty('--bar-left', `${left}px`);
    this.sectionOuter.style.setProperty('--bar-width', `${width}px`);
  }

  reset() {
    this.setDefault();
    if (defaultPositions && defaultPositions.left && defaultPositions.width) {
      this.sectionOuter.style.setProperty('--bar-left', `${defaultPositions.left}px`);
      this.sectionOuter.style.setProperty('--bar-width', `${defaultPositions.width}px`);
    } else {
      this.sectionOuter.style.setProperty('--bar-width', '0px');
    }
  }

  clearBar() {
    // allow the bar to jump between text sections for cart and main menu
    this.sectionOuter.setAttribute(selectors.isActive, false);
    setTimeout(() => {
      let active = this.sectionOuter.getAttribute(selectors.isActive) !== 'false';
      if (!active) {
        this.reset();
      }
    }, 150);
  }
}

const hoverUnderline = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.wrapper);
    els.forEach((el) => {
      sections[this.id].push(new HoverLine(el));
    });
  },
  onUnload: function () {
    sections[this.id].forEach((el) => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
    delete sections[this.id];
  },
};

export default hoverUnderline;
